export default "<p>\n  Ferdinando Martini (1841 – 1928) è stato uno scrittore e politico italiano.\n</p>\n";